import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"

import GuestLayout from "../components/GuestLayout"

import * as cartSlice from "../store/cart"
import * as userSlice from "../store/user"
import * as userApis from "../utilities/apis/user"

const Cart = () => {
  const dispatch = useDispatch()
  const cartState = useSelector((state) => state.cart)
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const handleCart = async (item) => {
    dispatch(cartSlice.addToCart(item))
  }

  const handleDecrement = async (item) => {
    dispatch(cartSlice.handleDecrement(item.slug))
  }

  const handleIncrement = async (item) => {
    if (cartState.productsById[item.slug] >= 5) return alert('For more than 5 quantity please contact our support on whatsapp')
    dispatch(cartSlice.handleIncrement(item.slug))
  }

  const handleSubmit = async (e) => {
    try {
      setLoading(true)
      e.preventDefault()

      const form = new FormData(e.target)
      const username = form.get("username")
      const password = form.get("password")

      if (!username) throw new Error("Username is required")
      if (!password) throw new Error("Password is required")

      const response = await userApis.login({ username, password })
      if (!response.status) throw new Error(response.message)

      dispatch(userSlice.login(response))
      navigate("/dashboard")
    } catch (error) {
      alert(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <GuestLayout
      header={true}
      footer={false}
    >
      <div className="container">
        <section className="py-3">
          <h3 className="fw-bold m-0">Cart</h3>
          <div className="row py-3">
            <div className="col-md-8">
              <div className="d-flex flex-column gap-3">
                {cartState.cart.map((item) => {
                  let src = "/upload.png"
                  if (item.thumbnail) src = item.thumbnail
                  // if (item.thumbnail_url) src = item.thumbnail_url.replace("public", url)

                  return (
                    <div className="card border-0 shadow-none">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center gap-3">
                          <img src={src} alt={item.title} className="thumbnail-img rounded" width={96} height={96} />
                          <div className="flex-grow-1">
                            <p className="lead text-body-emphasis fw-bold m-0">{item.title}</p>
                            <p className="fs-5 text-muted fw-semibold m-0">Rs. {(item.price - (item.discount || 0)).toFixed(2)}</p>
                          </div>
                          <div className="d-flex gap-3 justify-content-between align-items-center">
                            <button type="button" className="btn btn-light-theme flex-grow-1" onClick={() => handleDecrement(item)}><i className="bi bi-dash-lg"></i></button>
                            <p className="flex-grow-1 fs-5 text-muted text-center fw-bold m-0">{cartState.productsById[item.slug]}</p>
                            <button type="button" className="btn btn-light-theme flex-grow-1" onClick={() => handleIncrement(item)}><i className="bi bi-plus-lg"></i></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="col-md-4">
              <div className="card border-0 shadow-none">
                <div className="card-body">
                  <p className="fs-5 fw-bold mb-5">Summary</p>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <p className="lead text-body-emphasis fw-bold m-0">Subtotal</p>
                    <p className="fs-5 text-muted fw-semibold m-0">{cartState.cart.reduce((p, c) => p += c.price * cartState.productsById[c.slug], 0).toFixed(2)}</p>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <p className="lead text-body-emphasis fw-bold m-0">Discount</p>
                    <p className="fs-5 text-muted fw-semibold m-0">{cartState.cart.reduce((p, c) => p += c.discount * cartState.productsById[c.slug] || 0, 0).toFixed(2)}</p>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <p className="lead text-body-emphasis fw-bold m-0">Total</p>
                    <p className="fs-5 text-muted fw-semibold m-0">{(cartState.cart.reduce((p, c) => p += c.price * cartState.productsById[c.slug], 0) - cartState.cart.reduce((p, c) => p += c.discount * cartState.productsById[c.slug] || 0, 0)).toFixed(2)}</p>
                  </div>
                  <Link to="/checkout" className="btn btn-theme w-100">Continue to Checkout</Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </GuestLayout>
  )
}

export default Cart
